import React from 'react';
import { Link } from 'react-router-dom';
import { ONBOARDING_BACK_TO_LOGIN } from '../../../constants/Copy';
import { ROUTE_LOGIN_EMAIL } from '../../../constants/Routes';
import AccountNavLink from './AccountNavLink';

const BackToLogin = () => (
	<AccountNavLink>
		<Link className="onboarding__link" to={ROUTE_LOGIN_EMAIL}>
			{ONBOARDING_BACK_TO_LOGIN}
		</Link>
	</AccountNavLink>
);

export default BackToLogin;
